export const isCookieBlockerEnabled = async (): Promise<boolean> => {
  const result = await chrome.storage.local.get(["cookieBlockerEnabled"]);
  return result.cookieBlockerEnabled ?? true;
};
